import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";


const ComponentCategory = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    let response39 = useInvoke("WebApps", "39", {});

    useEffect(() => {

        //get all component categories
        if (response39.data.payload != undefined) {
            let myData = JSON.parse(response39.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "link", content: {text: `${entry[1]}`, link: `/ComponentCategory/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[2]}`}},
                {type: "text", content: {text: `${entry[3]}`}}
              ];
              rowsList.push(row);
            });
            setColumns(["Category Name", "Category Description", "Date Added"]);
            setRows(rowsList);
        }

    }, [response39.data.payload]);

    document.title = "Component Categories";
    return ( 
        <div className="componentCategories">

            {user["email"] != undefined &&
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>Component Categories</h2>
                        <p><Link className="btn btn-primary" to="/ComponentCategory/New">New Component Category</Link></p>
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true}/>}
                    </div>
                </>
            }
        </div>
     );
}
 
export default ComponentCategory;